<script>
import {VueMaskDirective as mask} from 'v-mask'
import service from '../../../../domain/arrematantes/services'
import * as Status from '../../../../domain/arrematantes/helpers/ArrematanteStatus'
import BtnStatus from './BtnStatus.vue'
import BtnStatusConfirmar from './ConfirmStatusAprovacao'
import TableLotes from './TableLotes'
import Desistencias from '../../leiloes/components/includes/Desistencias'
import ACL from '../../../../domain/acl/tmp-acl'
import {mapGetters} from 'vuex'
import AnaliseCadastral from './AnaliseCadastral'
import CampanhasArrematante from './Campanhas'

export default {
  components: {
    CampanhasArrematante,
    AnaliseCadastral,
    Desistencias,
    TableLotes,
    BtnStatus,
    BtnStatusConfirmar
  },
  nome: 'arrematante',
  directives: {mask},
  data () {
    return {
      arrematante: null,
      lances: null,
      lancesLoading: false,
      editarDocumentos: false,
      visualizarHistoricoOperacao: false
    }
  },
  computed: {
    apiUrl () {
      return process.env.API_URL
    },
    getStatus () {
      return Status.Status
    },
    getStatusDocumento () {
      let status = Status.StatusDocumento
      delete status[0]
      return status
    },
    enderecoPrincipal () {
      if (this.arrematante.pessoa.enderecos && this.arrematante.pessoa.enderecos.length > 0) {
        let endereco = this.arrematante.pessoa.enderecos.slice().shift()
        return [endereco]
      }
      return null
    },
    outrosEnderecos () {
      if (this.arrematante.pessoa.enderecos && this.arrematante.pessoa.enderecos.length > 1) {
        let enderecos = this.arrematante.pessoa.enderecos.slice()
        enderecos.shift()
        return enderecos
      }
      return null
    },
    getEmails () {
      if (!this.arrematante.pessoa.emails) {
        return 'Sem e-mail'
      }
      let emails = this.arrematante.pessoa.emails.slice().map((e) => {
        return e.email
      })
      return emails.join(', ')
    },
    interesseArrematante () {
      if (this.arrematante.tipoInteresseArrematante) {
        let interesses = []
        this.arrematante.tipoInteresseArrematante.forEach((element) => {
          interesses.push(element.nome)
        })
        return interesses.join(', ')
      }
      return 'Nenhum informado'
    },
    documentosRequeridosPendentes () {
      let documentosEnviados = this.arrematante.documentos.map((el) => {
        return el.documento ? el.documento.id : null
      }).filter(function (item, pos, self) {
        return self.indexOf(item) === pos
      })
      return this.arrematante.documentosRequeridos.filter(function (item) {
        return documentosEnviados.indexOf(item.id) === -1
      })
    },
    isApto () {
      let apto = true
      // Verifica se existe algum documento obrigatório sem enviar
      this.documentosRequeridosPendentes.forEach((item) => {
        if (item.obrigatorio) {
          apto = false
        }
      })
      // Verifica se existe algum documento não aprovado
      this.arrematante.documentos.forEach((item) => {
        if (item.status !== 2) {
          apto = false
        }
      })
      return apto
    },
    ACL () {
      return ACL
    },
    ...mapGetters(['isLogged', 'currentUser'])
  },
  mounted () {
    window.addEventListener('resize', this.ajustaTabelaLances)
  },
  activated () {
  },
  created () {
    this.load()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.ajustaTabelaLances)
  },
  deactivated () {
    this.$destroy() // no keep-alive
  },
  watch: {},
  methods: {
    load () {
      this.$loaderOverlay.open().message('Aguarde enquanto carregamos os dados do arrematante')
      service.find(this.$route.params.id)
        .then((response) => {
          this.$loaderOverlay.hide()
          this.arrematante = response.data
          this.ajustaTabelaLances()
          this.carregaLances()
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          console.log(response)
        })
    },
    ajustaTabelaLances () {
      this.$nextTick(() => {
        let tableLancesHead = this.$el.querySelector('#tableLancesHead')
        let tableLancesBody = this.$el.querySelector('#tableLances')
        if (tableLancesHead && tableLancesBody) {
          tableLancesHead.style.width = tableLancesBody.clientWidth + 'px'
        }
      })
    },
    carregaLances () {
      if (this.arrematante.apelido === 'PLATEIA') {
        return
      }
      this.lancesLoading = true
      service.getArrematanteLances(this.arrematante.id)
        .then((response) => {
          this.lancesLoading = false
          this.lances = response.data.lances
        })
        .catch((error) => {
          this.lancesLoading = false
          alert('Não foi possível carregar os lances')
          console.log(error)
        })
    },
    round: function (number, precision) {
      let factor = Math.pow(10, precision)
      let tempNumber = number * factor
      let roundedTempNumber = Math.round(tempNumber)
      return roundedTempNumber / factor
    },
    print: function () {
      window.print()
    },
    Status () {
      return Status
    },
    DocumentoStatus (status) {
      if (typeof Status.StatusDocumento[status] !== 'undefined') {
        return Status.StatusDocumento[status]
      }
      return {titulo: 'Status Inválido', class: ''}
    },
    confirmarAlteracaoStatus (v) {
      this.$refs.confirmarStatus.open(v, this.arrematante.status, (newStatus, motivos) => {
        let oldStatus = this.arrematante.status
        this.arrematante.status = newStatus
        let cb = (motivo = '') => {
          service.atualizaStatus(this.arrematante.id, newStatus, motivo)
            .then((response) => {
              // nothing to do
            })
            .catch((response) => {
              window.alert('Não foi possível atualizar o status, algum problema ocorreu, tente novamente.')
              this.lote.status = oldStatus
              console.log(response)
            })
        }
        if (/* parseInt(newStatus) === 98 || */parseInt(newStatus) === 99) {
          let motivo = prompt('Qual o motivo da não aprovação?')
          cb(motivo)
        } else {
          cb(motivos)
        }
      })
    },
    confirmarAlteracaoStatusDocumento (doc, status) {
      this.$refs.confirmarStatusDoc.open(status, doc.status, (newStatus) => {
        let oldStatus = doc.status
        doc.status = newStatus
        service.atualizaStatusDocumento(doc.id, newStatus)
          .then((response) => {
            // nothing to do
          })
          .catch((response) => {
            window.alert('Não foi possível atualizar o status, algum problema ocorreu, tente novamente.')
            doc.status = oldStatus
            console.log(response)
          })
      })
    },
    adjustFirstLetter (v) {
      return v.charAt(0).toLowerCase() + v.slice(1)
    },
    editar () {
      this.$router.push({name: 'arrematante.editar', params: {id: this.arrematante.id}})
    },
    editarUsuario () {
      this.$router.push({name: 'usuarios.visualizar', params: {id: this.arrematante.usuario}})
    },
    uploadDocumento (docid, e) {
      this.$loaderOverlay.open().message('Enviando Documento')
      let formData = new FormData()
      formData.append('arrematante[arquivo]', e.target.files[0], e.target.files[0].name)
      formData.set('arrematante[documento]', docid)
      // this.$refs.fileDocumento.value = ''
      service.uploadDocumento(this.arrematante.id, formData)
        .then((response) => {
          service.find(this.$route.params.id)
            .then((response) => {
              this.arrematante = response.data
              this.ajustaTabelaLances()
              this.carregaLances()
              this.$loaderOverlay.hide()
            })
            .catch((response) => {
              console.log(response)
              this.$loaderOverlay.hide()
            })
          // this.$set(this.lote.fotos, response.data)
          console.log(response)
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          window.alert('Não foi possível fazer o upload do documento, algum problema ocorreu, tente novamente.')
          console.log(response)
        })
    },
    removeDocumento (id) {
      this.$loaderOverlay.open().message('Deletando Documento')
      service.removeDocumento(id)
        .then((response) => {
          this.$loaderOverlay.hide()
          this.arrematante.documentos = this.arrematante.documentos.filter((d) => d.id !== id)
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          console.log(response)
          window.alert('Não foi possível excluir o documento')
        })
    },
    registroInadimplente () {
      let test = confirm('Tem certeza que deseja registrar este arrematante como inadimplente? Ele receberá o e-mail de cobrança imediatamente, e receberá semanalmente até o registro ser excluído.')
      if (test) {
        console.log('Registrando...')
        this.$loaderOverlay.open().message('Incluindo na base de inadimplentes...')
        service.incluirInadimplente(this.$route.params.id, {
          valor: null,
          observacoes: null
        })
          .then((response) => {
            this.$loaderOverlay.hide()
            this.arrematante.pendencias = response.data
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            console.log(response)
          })
      }
    },
    excluirInadimplente () {
      let test = confirm('Tem certeza que deseja excluir este arrematante da base de inadimplente?')
      if (test) {
        console.log('Excluindo...')
        this.$loaderOverlay.open().message('Excluindo da base de inadimplentes...')
        service.excluirInadimplente(this.arrematante.pendencias.id)
          .then((response) => {
            this.$loaderOverlay.hide()
            this.arrematante.pendencias = null
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            console.log(response)
          })
      }
    },

    registroImpedimento () {
      let test = confirm('Tem certeza que deseja registrar este arrematante na base de impedimentos / COAF?')
      if (test) {
        console.log('Registrando...')
        this.$loaderOverlay.open().message('Incluindo na base COAF...')
        service.incluirImpedimento(this.$route.params.id, {
          valor: null,
          observacoes: null
        })
          .then((response) => {
            this.$loaderOverlay.hide()
            this.arrematante.impedimentos = response.data
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            console.log(response)
          })
      }
    },
    excluirImpedimento () {
      let test = confirm('Tem certeza que deseja excluir este arrematante da base COAF?')
      if (test) {
        console.log('Excluindo...')
        this.$loaderOverlay.open().message('Excluindo da base COAF...')
        service.excluirImpedimento(this.arrematante.impedimentos.id)
          .then((response) => {
            this.$loaderOverlay.hide()
            this.arrematante.impedimentos = null
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            console.log(response)
          })
      }
    },
    analiseCadastral () {
      let test = confirm('Tem certeza que deseja executar a análise cadastral deste arrematante ?')
      if (test) {
        console.log('Analisando...')
        this.$loaderOverlay.open().message('Analisando cadastro...')
        service.analiseCadastral(this.arrematante.id)
          .then((response) => {
            this.$loaderOverlay.hide()
            console.log(response.data)
            this.$refs.analiseCadastral.show(response.data)
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            console.log(response)
          })
      }
    },
    excluirArrematante () {
      let test = confirm('Tem certeza que deseja excluir este arrematante? Esta operção NÃO PODERÁ MAIS SER DESFEITA')
      if (test) {
        let test2 = confirm('Confirme novamente para prosseguir com a EXCLUSÃO DO ARREMATANTE ' + this.arrematante.apelido)
        if (test2) {
          console.log('Excluindo arrematante...')
          this.$loaderOverlay.open().message('Excluindo arrematante da base de dados...')
          service.excluirArrematante(this.arrematante.id)
            .then((response) => {
              this.$loaderOverlay.hide()
              alert('Arrematante excluído com sucesso!')
              this.$router.push({name: 'arrematantes'})
            })
            .catch((response) => {
              this.$loaderOverlay.hide()
              alert('Falha ao tentar excluir o arrematante! Este arrematante pode conter lances e históricos obrigatórios no sistema. Consulte a equipe de TI.')
              console.log(response)
            })
        }
      }
    },
    limitarLance (r = true) {
      let test
      if (r) {
        test = confirm('Tem certeza que deseja limitar os lances deste arrematante?')
      } else {
        test = confirm('Tem certeza que deseja remover a limitação de lances deste arrematante?')
      }
      if (test) {
        this.$loaderOverlay.open().message('Atualizando cadastro do arrematante...')
        service.restringirLance(this.arrematante.id, r)
          .then((response) => {
            this.$loaderOverlay.hide()
            alert('Arrematante atualizado com sucesso!')
            this.load()
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            alert('Falha ao tentar atualizar o arrematante!')
            console.log(response)
          })
      }
    }
  }
}
</script>

<template>
  <transition name="slide">
    <div v-if="arrematante !== null" class="content-transition">
      <analise-cadastral ref="analiseCadastral" />
      <btn-status-confirmar :arrematante="arrematante" :Status="getStatus" ref="confirmarStatus"></btn-status-confirmar>
      <btn-status-confirmar :arrematante="arrematante" :Status="getStatusDocumento"
                            ref="confirmarStatusDoc"></btn-status-confirmar>
      <div class="fade-in-down">
        <div class="bg-light lter b-b wrapper-md">
          <div class="row">
            <div class="col-md-3">
              <!--<h1 class="m-n font-thin h3">#{{ arrematante.apelido }}</h1>
              <h1 class="m-n font-thin h3">{{ arrematante.pessoa.nome }}</h1>-->
              <h1 class="m-n font-thin h3">Arrematante</h1>
              <span class="label no-radius bg-dark"></span>
              <span class="label m-l-n-xxs no-radius bg-success "></span>
              <!--<span class="label m-l-n-xxs no-radius bg-white ">{{ lote.comitente.pessoa.nome }}</span>-->
            </div>
            <div class="col-md-9">
              <div class="visible-xs m-t-lg"></div>
              <u-button class="btn btn-sm btn-info pull-right pull-none-xs hidden-print" tabindex="1"
                        @click.prevent="print"><i class="fa fa-print m-r-xs"></i> Imprimir
              </u-button>

              <u-button class="btn btn-sm btn-default pull-right pull-none-xs m-r-sm hidden-print" tabindex="1"
                        @click.prevent="editarUsuario">
                <i class="fa fa-user-o m-r-xs"></i> Acesso
              </u-button>
              <u-button class="btn btn-sm btn-default pull-right pull-none-xs m-r-sm hidden-print" tabindex="1"
                        @click.prevent="editar">
                <i class="fa fa-edit m-r-xs"></i> Editar
              </u-button>

              <u-button v-if="!arrematante.pendencias"
                        class="btn btn-sm btn-default pull-right pull-none-xs m-r-sm hidden-print" tabindex="1"
                        @click.prevent="registroInadimplente">
                <i class="fa fa-money m-r-xs"></i> Incluir Inadimplente
              </u-button>
              <u-button v-else class="btn btn-sm btn-danger pull-right pull-none-xs m-r-sm hidden-print" tabindex="1"
                        @click.prevent="excluirInadimplente">
                <i class="fa fa-money m-r-xs"></i> Excluir da base de Inadimplentes
              </u-button>

              <u-button v-if="!arrematante.impedimentos"
                        class="btn btn-sm btn-default pull-right pull-none-xs m-r-sm hidden-print" tabindex="1"
                        @click.prevent="registroImpedimento">
                <i class="fa fa-ban m-r-xs"></i> Incluir COAF
              </u-button>
              <u-button v-else class="btn btn-sm btn-danger pull-right pull-none-xs m-r-sm hidden-print" tabindex="1"
                        @click.prevent="excluirImpedimento">
                <i class="fa fa-ban m-r-xs"></i> <strong>BASE COAF!</strong> Excluir
              </u-button>

              <u-button class="btn btn-sm btn-info pull-right pull-none-xs m-r-sm hidden-print" tabindex="1"
                        @click.prevent="analiseCadastral">
                <strong>Análise</strong> Cadastral
              </u-button>

              <btn-status :Status="getStatus" :value="arrematante.status" @input="confirmarAlteracaoStatus"
                          class="pull-right pull-none-xs m-r-sm hidden-print"></btn-status>
              <router-link :to="{name: 'arrematantes'}"
                           class="pull-right pull-none-xs hidden-print m-t-xs m-r"
                           style="clear: left"><strong class="label no-radius bg-info">Voltar</strong> para lista
              </router-link>
            </div>
          </div>
        </div>
        <div class="wrapper-md">

          <div v-if="arrematante.pendencias" class="alert alert-danger">
            Arrematante incluído na base de inadimplentes em {{arrematante.pendencias.dataInclusao.date}} e está
            recebendo cobranças periodicamente.
          </div>

          <div v-if="arrematante.urlContratoDigital">
            <a :href="arrematante.urlContratoDigital" target="_blank" class="btn btn-default">Ver contrato digital</a>
          </div>
          <div v-if="arrematante.urlContratoDigital">
            <a :href="`${arrematante.urlContratoDigital}&termo=1`" target="_blank" class="btn btn-default">Ver termo</a>
          </div>


          <div class="row">
            <div class="col-xs-6">
              <h4>{{ arrematante.pessoa.nome }}</h4>
              <p>{{ arrematante.apelido }}</p>

              <p v-for="endereco in enderecoPrincipal">
                {{ endereco.logradouro }}{{ endereco.numero && ', ' + endereco.numero }} {{ endereco.complemento &&
                endereco.complemento}} <br>
                {{ endereco.bairro }} {{ endereco.cep ? ', ' + endereco.cep : '' }}<br>
                {{ endereco.municipio ? endereco.municipio.nome : endereco.cidadeOutros }}, {{ endereco.municipio &&
                endereco.municipio.uf ? endereco.municipio.uf.nome : endereco.ufOutros }}
              </p>
              <p class="b-t" v-for="endereco in outrosEnderecos">
                {{ endereco.logradouro }}{{ endereco.numero && ', ' + endereco.numero }} {{ endereco.complemento &&
                endereco.complemento}} <br>
                {{ endereco.bairro }}<br>
                {{ endereco.municipio ? endereco.municipio.nome : endereco.cidadeOutros }}, {{ endereco.municipio &&
                endereco.municipio.uf ? endereco.municipio.uf.nome : endereco.ufOutros }}
              </p>
              <p>
                <span v-for="telefone in arrematante.pessoa.telefones">Telefone: {{ telefone.telefone | formataTelefone }}<i
                  v-if="telefone.celular" class="fa fa-mobile-phone m-l-xs"></i> <br></span>
              </p>
              <p>
                Email{{ arrematante.pessoa.emails && arrematante.pessoa.emails.length > 1 ? 's' : '' }}: <span>{{ getEmails  }}</span>
              </p>
              <p>
                IP origem cadastro: <span>{{ arrematante.pessoa.ipCadastro  }}</span>
              </p>
              <p v-if="arrematante.observacao" style="word-break: break-word">
                Observações:<br><br>
                {{ arrematante.observacao }}
              </p>
            </div>
            <div class="col-xs-6 text-right text-left-print">
              <p class="h4">#{{ arrematante.id }}</p>
              <h5>Se cadastrou{{ arrematante.pessoa.origem ? ' pelo ' + arrematante.pessoa.origem.origem.toLowerCase() :
                '' }} {{ moment(arrematante.pessoa.dataCadastro.date).format('LLLL') }}</h5>
              <div>
                {{ arrematante.pessoa.tipo === 1 ? 'Pessoa Física' : 'Pessoa Jurídica' }}<br>
                <div v-if="arrematante.pessoa.tipo === 1">
                  CPF: <span v-if="arrematante.pessoa.cpf">{{ arrematante.pessoa.cpf | formataCpf }}</span><span v-else>Sem CPF</span><br>
                  RG: {{ arrematante.pessoa.pfRg }} {{ arrematante.pessoa.pfRgOrgaoEmissor }} {{
                  arrematante.pessoa.pfRgDataExpedicao }}<br>
                  Nascimento: <span v-if="arrematante.pessoa.pfDataNascimento">{{ moment(arrematante.pessoa.pfDataNascimento.date).format('L') }}, {{arrematante.pessoa.pfDataNascimento.date|moment}}</span><br>
                  Estado Civil: {{ Status().EstadoCivil[arrematante.pessoa.pfEstadoCivil] }}<br>
                  Sexo: {{ arrematante.pessoa.pfSexo === 1 ? 'Masculino' : 'Feminino' }}<br>
                  <div v-if="arrematante.conjugeNome">
                    Cônjuge: {{ arrematante.conjugeNome }}<br>
                    CPF Cônjuge: <span
                    v-if="arrematante.conjugeCpf">{{ arrematante.conjugeCpf | formataCpf }}</span><span
                    v-else>Sem CPF</span><br>
                    RG Cônjuge: <span v-if="arrematante.conjugeRg">{{ arrematante.conjugeRg }}</span><span
                    v-else>Sem RG</span><br>
                  </div>
                </div>
                <div v-if="arrematante.pessoa.tipo === 2">
                  CNPJ: <span v-if="arrematante.pessoa.cnpj">{{ arrematante.pessoa.cnpj | formataCnpj }}</span><span
                  v-else>Sem CNPJ</span><br>
                  Inscrição Estadual: {{ arrematante.pessoa.pjInscricaoEstadual }}<br>
                  Nome Fantasia: {{ arrematante.pessoa.pjNomeFantasia }}<br>
                  Razão Social: {{ arrematante.pessoa.pjRazaoSocial }}<br>
                  Responsável: {{ arrematante.pessoa.pjResponsavel || arrematante.pjProprietarioNome }}<br>
                  CPF: <span
                  v-if="arrematante.pjProprietarioCpf">{{ arrematante.pjProprietarioCpf | formataCpf }}</span><span
                  v-else>SEM CPF DO RESPONSÁVEL</span>
                </div>
                <div class="m-t text-left restricao-container" style="padding: 10px; background-color: #f9f9f9; display: flex; justify-content: space-between">
                  <div>
                    Restrição de lance:<br><br>
                    <button @click="limitarLance(true)" v-if="!arrematante.restricoes || !arrematante.restricoes.lance" class="btn btn-success bg-success">Sem limite de lance</button>
                    <button @click="limitarLance(false)" v-else class="btn btn-danger bg-danger font-bold">Limitação de lance ativa</button>
                  </div>
                  <div>
                    Restrição de comitente:<br><br>
                    Sem restrição
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="panel wrapper-sm m-t b">
            <table width="100%" class="table table-condensed" cellspacing="2" cellpadding="2">
              <tbody>
              <tr>
                <td width="200">Situação do cadastro</td>
                <td>
                  <strong>{{ Status().Status[arrematante.status].titulo }}</strong> <a class="btn btn-xs"
                                                                                       @click="visualizarHistoricoOperacao = !visualizarHistoricoOperacao"><span
                  v-if="visualizarHistoricoOperacao">ocultar</span><span v-else>visualizar</span> histórico</a>
                  <div v-if="arrematante.historicoAprovacao && visualizarHistoricoOperacao">
                    <div v-for="o in arrematante.historicoAprovacao" :key="o.id">{{ o.username}} {{o.descricao}}
                      {{moment(o.data.date).format('L LTS')}}
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td width="200">Pode comprar sucata</td>
                <td><strong v-if="arrematante.podeComprarSucata">Sim</strong><strong class="text-danger"
                                                                                     v-else>Não</strong></td>
              </tr>
              <tr>
                <td width="200">Termo recebido</td>
                <td><strong v-if="arrematante.termoRecebido">Sim</strong><strong class="text-danger"
                                                                                 v-else>Não</strong></td>
              </tr>
              <tr>
                <td width="200">Interesse do arrematante</td>
                <td><strong>{{ interesseArrematante }}</strong></td>
              </tr>
              <tr>
                <td width="200">Deseja receber newsletter</td>
                <td><strong>{{ arrematante.newsletter ? 'Sim' : 'Não' }}</strong></td>
              </tr>
              </tbody>
            </table>
            <!--Situação do cadastro: <strong>{{ Status().Status[arrematante.status].titulo }}</strong><br>
            Pode comprar sucata: <strong v-if="arrematante.podeComprarSucata">Sim</strong><strong class="text-danger"
                                                                                                  v-else>Não</strong><br>
            Termo recebido: <strong v-if="arrematante.termoRecebido">Sim</strong><strong class="text-danger"
                                                                                         v-else>Não</strong><br>
            Interesse do arrematante: <strong>{{ interesseArrematante }}</strong><br>
            Deseja receber newsletter: <strong>{{ arrematante.newsletter ? 'Sim' : 'Não' }}</strong><br>-->
          </div>
          <!--<strong>{{ arrematante.pessoa && arrematante.pessoa.nome.split(' ').shift() }}</strong> se cadastrou <strong>{{
          moment(arrematante.pessoa.dataCadastro.date).format('LLLL') }}</strong>.-->

          <div class="hidden-print">
            <div v-if="arrematante.status === 0" class="alert"
                 :class="{'alert-warning': !isApto, 'alert-success': isApto}">
              <div v-if="isApto">Este arrematante <span
                class="text-success font-bold">está apto para ser aprovado</span>, de acordo à aprovação dos documentos
                verificados.
              </div>
              <div v-else>Este arrematante <span class="text-danger font-bold">não está apto para ser aprovado</span>.
                Verifique a documentação obrigatória. Caso considere-o apto, é possível aprovar mesmo com esta
                restrição.
              </div>
            </div>
            <h4>Documentos</h4>
            <div class="m-b">
              <label class="i-switch i-switch-xs bg-success m-t-xs m-r">
                <input type="checkbox" v-model="editarDocumentos">
                <i></i>
              </label> Editar Documentos
            </div>
            <div class="row">
              <div v-for="doc in arrematante.documentos" class="col-lg-3 col-md-6 col-sm-6 clearfix">
                <div class="panel wrapper-sm">
                  <table class="table table-condensed">
                    <tbody>
                    <tr>
                      <!--<td>Documento</td>-->
                      <td colspan="2">
                        <strong>{{ doc.documento ? doc.documento.nome : 'Aplicativo' }}</strong><br>
                        <i v-if="!doc.documento"></i>
                        <i v-else-if="doc.documento.obrigatorio"
                           class="label label-xs label-warning font-normal">Obrigatório</i><i
                        class="label label-xs label-default font-normal" v-else>Não Obrigatório</i>
                      </td>
                    </tr>
                    <tr>
                      <td>Envio</td>
                      <td>
                        <div><strong style="font-size: 12px">{{ moment(doc.dataCadastro.date).format('L') }} {{
                          moment(doc.dataCadastro.date).format('LT') }}</strong></div>
                      </td>
                    </tr>
                    <tr>
                      <td>Formato</td>
                      <td><strong>{{ doc.arquivo.split('.').pop().toUpperCase() }}</strong></td>
                    </tr>
                    <tr>
                      <td>Status</td>
                      <td :class="'text-' + DocumentoStatus(doc.status).class">
                        <btn-status :Status="getStatusDocumento" :value="doc.status"
                                    @input="confirmarAlteracaoStatusDocumento(doc, $event)"
                                    class=""></btn-status><!--{{ DocumentoStatus(doc.status).titulo }}--></td>
                    </tr>
                    <!--<tr>
                      <td colspan="2"><iframe width="100%" height="200" :src="apiUrl + '/uapi/arrematantes/documentos/' + doc.arquivoHash"></iframe> </td>
                    </tr>-->
                    <!--<tr>
                      <td colspan="2"><strong>{{ doc.nome }}</strong></td>
                    </tr>-->
                    <tr>
                      <td colspan="2"><a :title="doc.nome"
                                         :href="apiUrl + '/uapi/arrematantes/documentos/' + doc.arquivoHash"
                                         target="_blank" class="btn btn-default btn-block">Visualizar Documento</a></td>
                    </tr>
                    <tr v-if="editarDocumentos">
                      <td colspan="2" class="text-center" align="center">
                        <button @click="removeDocumento(doc.id)" class="btn btn-xs bg-danger" title="Remover"><i
                          class="fa fa-trash"></i></button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div v-for="doc in documentosRequeridosPendentes" class="col-lg-3 col-md-6 col-sm-6 ">
                <div class="panel bg-white-opacity wrapper-sm">
                  <table class="table table-condensed">
                    <tbody>
                    <tr>
                      <!--<td>Documento</td>-->
                      <td colspan="2">
                        <strong>{{ doc.nome }}</strong><br>
                        <i v-if="doc && doc.obrigatorio" class="label label-xs label-warning font-normal">Obrigatório</i><i
                        class="label label-xs label-default font-normal" v-else>Não Obrigatório</i>
                      </td>
                    </tr>
                    <tr>
                      <td>Envio</td>
                      <td><strong>-</strong></td>
                    </tr>
                    <tr>
                      <td>Formato</td>
                      <td><strong>-</strong></td>
                    </tr>
                    <tr>
                      <td>Status</td>
                      <td>
                        <div class="btn-group dropdown">
                          <button class="btn btn-sm disabled" data-toggle="dropdown" tabindex="1" aria-expanded="false">
                            <i class="fa fa-warning m-r-xs"></i> Não enviado
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2"><a target="_blank" class="btn btn-default disabled btn-block">Aguardando Envio</a>
                      </td>
                    </tr>
                    <tr v-if="editarDocumentos">
                      <td colspan="2" class="text-center" align="center">
                        <button class="btn btn-xs bg-info fileContainer" title="Upload">
                          <i class="fa fa-upload"></i>
                          <input
                            @change="uploadDocumento(doc.id, $event)" :ref="'fileDocumento' + doc.id" type="file" />
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>

            </div>
          </div>

          <div v-if="arrematante.apelido !== 'PLATEIA'" class="">

            <!-- Lotes Arrematados -->
            <h4>Arremates</h4>
            <table-lotes class="m-b" :arrematante="arrematante"></table-lotes>

            <h4>Participação em Leilões</h4>
            <div class="bg-black">
              <!--<div class="wrapper-sm bg-dark font-bold text-uppercase">Participação em Leilões</div>-->
              <div class="bg-black pos-rlt hidden-print" id="tableLancesHead">
                <table class="table table-black bg-black m-b-none">
                  <thead>
                  <tr>
                    <th style="width: 33%">Data</th>
                    <th style="width: 33%">Lote</th>
                    <th style="width: 33%">Valor</th>
                  </tr>
                  </thead>
                </table>
              </div>
              <div class="scroll-black scroll-lote">
                <table class="table table-black table-lance-black-topneg" id="tableLances">
                  <thead>
                  <tr>
                    <th style="width: 33%">Data</th>
                    <th style="width: 33%">Lote</th>
                    <th style="width: 33%">Valor</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="lance in lances">
                    <td>{{ moment(lance.data.date).format('L') }} {{ moment(lance.data.date).format('LTS') }}</td>
                    <td>
                      <router-link target="_blank"
                                   :to="{name: 'lotes.visualizar', params: {leilao: lance.leilaoId, id: lance.loteId}}">
                        {{ lance.loteTitulo }}
                      </router-link>
                    </td>
                    <td>R$ {{ lance.valor | moeda }}</td>
                  </tr>
                  <tr v-if="(!lances || lances.length === 0) && !lancesLoading">
                    <td colspan="3" class="no-borders" style="border-bottom: none"><span class="text-danger">Nenhum lance</span>
                    </td>
                  </tr>
                  <tr v-if="lancesLoading">
                    <td colspan="3" class="no-borders text-center" style="border-bottom: none"><i
                      class="fa fa-spin fa-spinner m-t fa-2x"></i></td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <br>
            <desistencias :arrematante="arrematante.id" />

            <campanhas-arrematante :arrematante="arrematante" />

            <a v-if="ACL.check('excluir_arrematante', currentUser.id)" class="btn btn-danger m-t-xxl btn-xs" @click="excluirArrematante">EXCLUIR DEFINITIVAMENTE ESTE ARREMATANTE DO SISTEMA</a>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// VisualizarArrematante.vue?15d3331e